import { I18n } from '@calendly/i18n'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CopyIcon } from '@calendly/ui/components/icons'

import { IconThumbsUpFill, IconThumbsUpOutline, IconThumbsDownFill, IconThumbsDownOutline } from '../assets'

export const IconButtons = ({ onCopy, onLike, onDislike, isLiked, isDisliked }) => (
  <FlexLayout gap="8">
    <IconButton
      size="small"
      title={{
        text: I18n.t('publisher.agent_hub.good_response'),
        placement: 'bottom'
      }}
      onClick={onLike}
    >
      {isLiked ? <IconThumbsUpFill /> : <IconThumbsUpOutline />}
    </IconButton>
    <IconButton
      size="small"
      title={{
        text: I18n.t('publisher.agent_hub.bad_response'),
        placement: 'bottom'
      }}
      onClick={onDislike}
    >
      {isDisliked ? <IconThumbsDownFill /> : <IconThumbsDownOutline />}
    </IconButton>
    <IconButton
      size="small"
      title={{
        text: I18n.t('publisher.agent_hub.copy'),
        placement: 'bottom'
      }}
      onClick={onCopy}
    >
      <CopyIcon />
    </IconButton>
  </FlexLayout>
)
